export default __webpack_public_path__ + "static/media/Picture6.d79525c4.jpg";